



























































import ModalTabMixin from '@/mixins/modal-tab.mixin';
import { Component, Mixins } from 'vue-property-decorator';
import { i18n } from '@/i18n';
import TableMixin from '@/mixins/table.mixin';
import { IPolicy } from '@resclick/data-access';
import Modal from './policies.modal.vue';

@Component({
  components: {
    Modal,
  },
})
export default class TabPolicies extends Mixins(ModalTabMixin, TableMixin) {
  query = {
    params: { companyId: this.id },
  };

  columns = [
    {
      label: 'GENERAL.STATUS',
      name: 'isActive',
      sortable: true,
      align: 'center',
    },
    {
      label: 'GENERAL.NAME',
      name: 'name',
      sortable: true,
      align: 'center',
    },
    {
      label: 'GENERAL.TYPE',
      name: 'type',
      sortable: true,
      field: (row: IPolicy) => row.type && i18n.tc('GENERAL.' + row.type),
    },
    {
      label: 'GENERAL.LANGUAGES',
      name: 'languages',
      sortable: true,
      field: (row: IPolicy) => row.type && i18n.tc('GENERAL.' + row.type),
    },
    { label: 'GENERAL.ACTIONS', name: 'actions', align: 'center' },
  ];
}
